import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgThermostaat = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15"
    />
    <path
      fill="#FFBFA5"
      d="M20 32.5c6.904 0 12.5-5.596 12.5-12.5S26.904 7.5 20 7.5 7.5 13.096 7.5 20 13.096 32.5 20 32.5"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20.32 8.143a11.9 11.9 0 0 0-5.924 1.542l-.492-.87A12.88 12.88 0 0 1 33.13 19.999a13 13 0 0 1-.478 3.506l-.963-.27a11.881 11.881 0 0 0-11.37-15.092"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="m14.26 19.09-1.84 1.11-1-1.7L14.5 16h2.19v8.65h-2.43zM18 22.25a2.05 2.05 0 0 1 1.34-2 2 2 0 0 1-.95-1.88c0-1.36 1.08-2.46 3-2.46s3 1.1 3 2.46a2 2 0 0 1-.95 1.88 2.05 2.05 0 0 1 1.34 2c0 1.55-1.22 2.58-3.42 2.58S18 23.8 18 22.25m4.31-.37a.89.89 0 1 0-.89.88.81.81 0 0 0 .93-.88zm0-3.1a.87.87 0 1 0-.87.84.79.79 0 0 0 .89-.84zM25.45 17a1.81 1.81 0 1 1 1.81 1.81A1.77 1.77 0 0 1 25.45 17M28 17a.72.72 0 1 0-1.437.08A.72.72 0 0 0 28 17"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M12.107 30.228a12.92 12.92 0 0 1-4.962-8.489l.99-.138a11.92 11.92 0 0 0 4.578 7.831z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgThermostaat);

export default ForwardRef;
